/* eslint-disable */

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  // `trace` records the stack of whatever dispatched each action, so the Redux DevTools "Trace"
  // tab points straight at the code that changed a filter. Development only.
  devTools: process.env.NODE_ENV === 'development' && { trace: true, traceLimit: 30 },
});

//@ts-ignore
if (process.env.NODE_ENV === 'development' && module.hot) {
  //@ts-ignore
  module.hot.accept('./rootReducer', () => {
    const newRootReducer = require('./rootReducer').default;
    store.replaceReducer(newRootReducer);
  });
}

export type AppDispatch = typeof store.dispatch;

export default store;
